export const determineMarketOutcome = (marketCode, gameName) => {
  const teams = gameName.split(" V ");
  const homeTeam = teams[0];
  const awayTeam = teams[1];
  if (marketCode === "X") {
    return { type: "Draw" };
  } else if (marketCode === "1") {
    return { type: "Team", team: homeTeam }; // Home team wins
  } else if (marketCode === "2") {
    return { type: "Team", team: awayTeam }; // Away team wins
  } else if (marketCode === "12") {
    return { type: "Team", team: `${homeTeam} or ${awayTeam}` }; // No draw
  } else if (
    marketCode === "X1" ||
    marketCode === "x1" ||
    marketCode === "1x" ||
    marketCode === "1X"
  ) {
    return { type: "Team", team: `Draw or ${homeTeam}` }; // Draw or home win
  } else if (
    marketCode === "X2" ||
    marketCode === "x2" ||
    marketCode === "2x" ||
    marketCode === "2X"
  ) {
    return { type: "Team", team: `Draw or ${awayTeam}` }; // Draw or away win
  }
  return { type: marketCode };
};
